import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Apiservice from '../Apiservice';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const StaffAttendance = () => {
    const navigate = useNavigate();

    const [staffs, setStaffs] = useState([]);
    const [roles, setRoles] = useState([]);
    const [sites, setSites] = useState([]);

    const [staffId, setStaffId] = useState('');
    const [roleId, setRoleId] = useState('');
    const [siteId, setSiteId] = useState('');
    const [siteIn, setSiteIn] = useState(null);
    const [latitude, setLatitude] = useState(0.00);
    const [longitude, setLongitude] = useState(0.00);
    const [errors, setErrors] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            const data = { status: 0 };
            let result = await Apiservice.AttendanceEditPage(data);

            if (result.success === true) {
                const retrievedData = result.data;
                setRoles(retrievedData.roles);
                setSites(retrievedData.sites);
                setStaffs(retrievedData.users);
            }
        };
        fetchData();
    }, []);

    const parseDateTimeForStorage = (dateObj) => {
        if (!dateObj) return "";
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');
        const hours = String(dateObj.getHours()).padStart(2, '0');
        const minutes = String(dateObj.getMinutes()).padStart(2, '0');
        const seconds = String(dateObj.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };

    const siteChange = async (selectedSiteId) => {
        setSiteId(selectedSiteId);
        const site = sites.find((site) => site.id === parseInt(selectedSiteId));
        if (site) {
            setLatitude(site.latitude);
            setLongitude(site.longitude);
        }
    };

    const validateForm = () => {
        const newErrors = {};
        if (!staffId) newErrors.staffId = "Please select a staff member";
        if (!roleId) newErrors.roleId = "Please select a role";
        if (!siteId) newErrors.siteId = "Please select a site";
        if (!siteIn) newErrors.siteIn = "Please select check-in time";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSave = async () => {
        if (!validateForm()) return;

        const data = {
            site_id: siteId,
            user_id: staffId,
            role_id: roleId,
            entryTime: parseDateTimeForStorage(siteIn),
            entryLatitude: latitude,
            entryLongitude: longitude,
            status: 0
        };

        let result = await Apiservice.CheckInAttendance(data);
        if (result.success === true) {
            alert("Attendance added successfully!");
            navigate('/attendance');
        } else {
            alert(result.message);
        }
    };

    return (
        <div className="container mt-4">
            <div className="card shadow p-4">
                <h4 className="mb-4 text-primary text-center">Add Staff Attendance</h4>

                {/* Staff Selection */}
                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Staff Name</label>
                    <div className="col-sm-6">
                        <select
                            className={`form-select form-select-sm ${errors.staffId ? 'is-invalid' : ''}`}
                            value={staffId}
                            onChange={(e) => setStaffId(e.target.value)}
                        >
                            <option value="">Select Staff</option>
                            {staffs.map((staff) => (
                                <option key={staff.id} value={staff.id}>
                                    {staff.firstName} {staff.lastName}
                                </option>
                            ))}
                        </select>
                        {errors.staffId && <div className="invalid-feedback">{errors.staffId}</div>}
                    </div>
                </div>

                {/* Role Selection */}
                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Role</label>
                    <div className="col-sm-6">
                        <select
                            className={`form-select form-select-sm ${errors.roleId ? 'is-invalid' : ''}`}
                            value={roleId}
                            onChange={(e) => setRoleId(e.target.value)}
                        >
                            <option value="">Select Role</option>
                            {roles.filter(role => role.id !== 1).map((role) => (
                                <option key={role.id} value={role.id}>
                                    {role.name}
                                </option>
                            ))}
                        </select>
                        {errors.roleId && <div className="invalid-feedback">{errors.roleId}</div>}
                    </div>
                </div>

                {/* Site Selection */}
                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Site</label>
                    <div className="col-sm-6">
                        <select
                            className={`form-select form-select-sm ${errors.siteId ? 'is-invalid' : ''}`}
                            value={siteId}
                            onChange={(e) => siteChange(e.target.value)}
                        >
                            <option value="">Select Site</option>
                            {sites.map((site) => (
                                <option key={site.id} value={site.id}>
                                    {site.name}
                                </option>
                            ))}
                        </select>
                        {errors.siteId && <div className="invalid-feedback">{errors.siteId}</div>}
                    </div>
                </div>

                {/* Site In Date Picker */}
                <div className="mb-3 row">
                    <label className="col-sm-3 col-form-label">Site In</label>
                    <div className="col-sm-6">
                        <DatePicker
                            selected={siteIn}
                            onChange={(date) => setSiteIn(date)}
                            showTimeSelect
                            timeFormat="HH:mm"
                            timeIntervals={15}
                            dateFormat="dd-MM-yyyy HH:mm:ss"
                            placeholderText="Select In Time"
                            className={`form-control form-control-sm ${errors.siteIn ? 'is-invalid' : ''}`}
                            isClearable
                        />
                        {errors.siteIn && <div className="invalid-feedback d-block">{errors.siteIn}</div>}
                    </div>
                </div>

                {/* Submit Button */}
                <div className="mt-4 text-center">
                    <button className="btn btn-primary btn-sm px-4" onClick={handleSave}>
                        Check-In
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StaffAttendance;
